import { combineReducers, configureStore } from '@reduxjs/toolkit'
import { userReducer } from '@src/store/ducks/user/reducer'
import { couponsReducer } from '@src/store/ducks/coupons/reducer'
import { appReducer } from './ducks/app/reducer'
import { authReducer } from './ducks/auth/reducer'

const combinedReducer = combineReducers({
  app: appReducer,
  isAuth: authReducer,
  user: userReducer,
  coupons: couponsReducer,
})

const rootReducer = (state: any, action: any) => {
  let tmpState = state
  if (action.type === 'auth/logoutAC') {
    tmpState = undefined
  }
  return combinedReducer(tmpState, action)
}

export const store = configureStore({
  reducer: rootReducer,
  devTools: process.env.NODE_ENV !== 'production',
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
